module.exports = __webpack_public_path__ + "static/media/education-object-2-1-0.ba898569.png";